import type { User } from '@evenfinancial/auth-client';

import type { UserCreateData, UserUpdateData } from '@portal/api-models';

import { client } from '../client';

export const createUser = async (data: UserCreateData) =>
  client.post('/user', data).then<User>(({ data }) => data);

export const updateUser = async (uuid: string, data: UserUpdateData) =>
  client.post(`/user/${uuid}`, data).then<User>(({ data }) => data);
